var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#0B7011"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9998 20.166C36.2915 20.166 20.1665 36.291 20.1665 55.9993C20.1665 75.7077 36.2915 91.8327 55.9998 91.8327C75.7082 91.8327 91.8332 75.7077 91.8332 55.9993C91.8332 36.291 75.7082 20.166 55.9998 20.166ZM48.8332 73.916L30.9165 55.9993L35.969 50.9468L48.8332 63.7752L76.0307 36.5777L81.0832 41.666L48.8332 73.916Z",
    fill: "#048C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7c08b517c182f01927de1579b69c83b4.svg";
export { ForwardRef as ReactComponent };